window.ClientLogosSwitcher = (function(window,jQuery){
	var ClientLogosSwitcher = {
							'visibleLogos': 1,
							'logosArray': ['logo5', 'logo2', 'logo3','logo4','logo1','logo10','logo7','logo8','logo9','logo6','logo11','logo12', 'logo16', 'logo14', 'logo13', 'logo15'],
							'interval': false,
							'intervalTiming': 8000
						 };

	ClientLogosSwitcher.swapLogos = function(){
		for (i = 0; i < ClientLogosSwitcher.visibleLogos; i++) { 
			var logoContainer = $('body').find('.client-logos .client-logo')[i],
				clazz = ClientLogosSwitcher.logosArray.shift();
				$(logoContainer).append($('<span>').addClass('logo second-logo ' + clazz));
				ClientLogosSwitcher.logosArray.push(clazz);
		}

		setTimeout(function(){
			$('.client-logos').find('span.logo').addClass('hide');
			$('.client-logos').find('span.second-logo').removeClass('second-logo hide');
			setTimeout(function(){
				$('.client-logos').find('.hide').remove();
			},2400);
		},200);
	}

	ClientLogosSwitcher.checkNumVisible = function(){
		ClientLogosSwitcher.visibleLogos = $('body').find('.client-logos .client-logo:visible').length;
	}

	ClientLogosSwitcher.resizeLogoUpdate = function(oldVis){
		var oldVis = oldVis;
		for (i = oldVis; i < $('body').find('.client-logos .client-logo:visible').length; i++) { 
			var logoContainer = $('body').find('.client-logos .client-logo')[i],
				clazz = ClientLogosSwitcher.logosArray.shift();
				$(logoContainer).html('').append($('<span>').addClass('logo ' + clazz));
				ClientLogosSwitcher.logosArray.push(clazz);
		}
	}

	ClientLogosSwitcher.init = function(){
		ClientLogosSwitcher.checkNumVisible();
		ClientLogosSwitcher.swapLogos();
		ClientLogosSwitcher.interval = setInterval(ClientLogosSwitcher.swapLogos,ClientLogosSwitcher.intervalTiming);
	}

	ClientLogosSwitcher.destroy = function(){
		if(ClientLogosSwitcher.interval !== false){
			clearInterval(ClientLogosSwitcher.interval);
			ClientLogosSwitcher.interval = false;
		}
	}

	$(window).resize(function(){
		if($('body').find('.client-logos .client-logo:visible').length > ClientLogosSwitcher.visibleLogos){
			ClientLogosSwitcher.destroy();
			ClientLogosSwitcher.resizeLogoUpdate(ClientLogosSwitcher.visibleLogos);
			ClientLogosSwitcher.interval = setInterval(ClientLogosSwitcher.swapLogos,ClientLogosSwitcher.intervalTiming);
		}
		ClientLogosSwitcher.checkNumVisible();
	});

	return ClientLogosSwitcher;
})(window,jQuery);